<template>
  <div class="container-fluid pt-0">
    <DeleteGroupRecord
      v-if="deleteRecordModal"
      :show="deleteRecordModal"
      :record="singlerecord.record"
      :group="singlegroup.group"
      v-on:closeDeleteRecordModal="deleteRecordModal = false"
    />
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <div v-if="singlerecord.record" class="row">
      <div class="col-md-5 align-self-center">
        <h4 class="">
          {{ singlerecord.record.name }}
        </h4>
        <button
          class="mb-2 btn btn-secondary"
          v-if="!singlerecord.record.end"
          @click.prevent="endrecord"
        >
          {{$t("end_trip")}}
        </button>
      </div>
      <div class="col-md-7 align-self-center">
        <div class="d-flex align-items-start justify-content-end py-2">
          <!-- <div class="mr-2 btn-group">
            <button @click.prevent="getLocations" class="btn btn-secondary">
              View Trip
            </button>
          </div> -->
          <div v-click-outside="closeExport" class="btn-group">
            <button
              id="btnGroupDrop1"
              type="button"
              class="btn btn-primary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              @click.prevent="exportShow = !exportShow"
            >
              {{$t("exp")}}
            </button>
            <div class="dropdown-menu" v-bind:class="{ show: exportShow }">
              <a
                href="javascript:void(0)"
                @click.prevent="downloadpdf"
                class="dropdown-item"
                style="border: 1px solid rgba(0, 0, 0, 0.4); border-radius: 5px"
              >
                {{$t("exp_pdf")}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div
          class="d-flex justify-content-space-around col-md-8 col-lg-6 mx-auto"
        >
          <div class="btn-container">
            <button
              @click="showGraph('temp')"
              :disabled="tempGraph == true"
              id="graphselect"
            >
              {{$t("temp")}}
            </button>
          </div>
          <div class="btn-container">
            <button
              @click="showGraph('humi')"
              :disabled="tempGraph == false"
              id="graphselect"
            >
              {{$t("humid")}}
            </button>
          </div>
        </div>
        <div
          class="d-flex justify-content-space-around flex-wrap m-t-10 col-md-10 col-lg-8 mx-auto"
        >
          <div class="btn-container w-20">
            <button
              id="typeselect"
              :disabled="defaultrecordtype > 1 || singlerecord.type == 'default'"
              @click="fetchgroupdevicestats('default')"
              class="mr-1"
              :class="{ selectrange: singlerecord.type == 'default' }"
            >
              {{$t("default")}}
            </button>
          </div>
          <div class="btn-container w-20">
            <button
              id="typeselect"
              @click="fetchgroupdevicestats('hourly')"
              :disabled="defaultrecordtype > 2 || singlerecord.type == 'hourly'"
              class="mr-1"
              :class="{ selectrange: singlerecord.type == 'hourly' }"
            >
              {{$t("hrly")}}
            </button>
          </div>
          <div class="btn-container w-20">
            <button
              id="typeselect"
              @click="fetchgroupdevicestats('daily')"
              :disabled="defaultrecordtype > 3 || singlerecord.type == 'daily'"
              class="mr-1"
              :class="{ selectrange: singlerecord.type == 'daily' }"
            >
              {{$t("daily")}}
            </button>
          </div>
          <div class="btn-container w-20">
            <button
              id="typeselect"
              @click="fetchgroupdevicestats('monthly')"
              :disabled="defaultrecordtype > 4 || singlerecord.type == 'monthly'"
              class="mr-1"
              :class="{ selectrange: singlerecord.type == 'monthly' }"
            >
              {{$t("monthly")}}
            </button>
          </div>
          <div class="btn-container w-20">
            <button
              id="typeselect"
              @click="fetchgroupdevicestats('yearly')"
              :disabled="singlerecord.type == 'yearly'"
              :class="{ selectrange: singlerecord.type == 'yearly' }"
            >
              {{$t("yearly")}}
            </button>
          </div>
        </div>
        <div ref="content" id="my-node">
          <CombinedGroupChart
            :tempGraph="tempGraph"
            :humiGraph="humiGraph"
            :defaultrecordtype="defaultrecordtype"
            :recordtype="singlerecord.type"
            :devicestats="singlerecord.allStats"
            v-on:show-graph="showGraph"
            v-on:fetchgroupdevicestats="fetchgroupdevicestats"
          />
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div
          class="row"
          style="display: flex; justify-content: space-between; align-items: center"
        >
          <div class="col-md-8">
            <h5>{{$t("del_rec")}}</h5>
            <p class="mb-0">
              {{$t("del_perm")}}
            </p>
          </div>
          <div class="col-md-4 deleterecord">
            <button class="btn btn-danger" @click="deleteRecordModal = true">
              {{$t("del_rec")}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import jsPDF from "jspdf";

// import html2canvas from "html2canvas";
import domtoimage from "dom-to-image";

import moment from "moment";
import vClickOutside from "v-click-outside";
// import CombinedGroupChart from "../../components/Groups/CombinedGroupChart";
import DeleteGroupRecord from "../Modals/DeleteGroupRecord";

export default {
  name: "DeviceReport",
  components: {
    Loading,
    CombinedGroupChart: () =>
      import(
        /* webpackPrefetch: true */ "../../components/Groups/CombinedGroupChart"
      ),
    DeleteGroupRecord,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      tempGraph: true,
      humiGraph: false,
      deleteRecordModal: false,
      mssg: "",
      Errormssg: "",
      exportShow: false,
      defaultrecordtype: 0,
    };
  },
  mounted() {
    this.getBusinessProfile();
    this.fetchSingleGroup({ id: this.$route.params.id });

    this.fetchSingleGroupRecord({
      id: this.$route.params.id,
      recordId: this.$route.params.record_id,
    })
      .then(() => {
        if (this.singlerecord.type == "default") {
          this.defaultrecordtype = 1;
        } else if (this.singlerecord.type == "hourly") {
          this.defaultrecordtype = 2;
        } else if (this.singlerecord.type == "daily") {
          this.defaultrecordtype = 3;
        } else if (this.singlerecord.type == "monthly") {
          this.defaultrecordtype = 4;
        } else if (this.singlerecord.type == "yearly") {
          this.defaultrecordtype = 5;
        }
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.response) {
          console.log(error.response);
          // this.$router.push("/404");
        }
      });
  },

  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([
      "singlerecord",
      "singlegroup",
      "businessprofile",
      "recordlocations",
    ]),
  },
  methods: {
    ...mapActions([
      "fetchSingleGroupRecord",
      "deleteGroupRecord",
      "endGroupRecord",
      "fetchSingleGroup",
      "getBusinessProfile",
      "fetchSingleGroupRecordCustom",
      "fetchSingleGroupRecordLocations",
    ]),
    // getLocations() {
    //   this.isLoading = true;
    //   this.fetchSingleGroupRecordLocations({
    //     id: this.$route.params.id,
    //     recordId: this.$route.params.record_id,
    //   }).then(() => {
    //     // console.log(this.recordlocations, "locations")
    //     this.isLoading = false;
    //     this.locationpoints = "";
    //     let length = this.recordlocations.length;
    //     // console.log(length, "length")
    //     for (let i = 0; i < length - 1; i++) {
    //       // console.log(i, "i")
    //       // console.log(this.recordlocations[i]._id.latitude)
    //       if (
    //         this.recordlocations[i]._id.latitude != 0 &&
    //         this.recordlocations[i]._id.longitude != 0
    //       ) {
    //         this.locationpoints += this.recordlocations[i]._id.latitude + ",";
    //         this.locationpoints += this.recordlocations[i]._id.longitude + "/";
    //       }
    //     }
    //     this.locationpoints +=
    //       this.recordlocations[length - 1]._id.latitude + ",";
    //     this.locationpoints += this.recordlocations[length - 1]._id.longitude;
    //     // console.log(this.locationpoints, "points")
    //     // https://www.google.com/maps/dir/6.5802681,3.2811561/6.458985,3.601521/6.612320,3.363310
    //     window.open(
    //       `https://www.google.com/maps/dir/${this.locationpoints}`,
    //       "_blank"
    //     );
    //   });
    // },
    downloadpdf() {
      this.isLoading = true;
      this.exportShow = false;
      // //console.log(this.datatable);
      //console.log(this.record.stats);
      if (screen.width < "992") {
          document.getElementById("my-node").style.width = "1440px";
        }
        var node = document.getElementById("my-node");
      var imgUrl =
        "data:image/png;base64,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";
      var companyImg = this.businessprofile.image;
      // console.log(companyImg);
      var c = document.createElement("canvas");
      var img = document.createElement("img");
      img.crossOrigin = "anonymous";
      img.src = companyImg;
      var doc = new jsPDF();

      setTimeout(() => {
        c.height = img.naturalHeight;
        c.width = img.naturalWidth;
        var ctx = c.getContext("2d");

        ctx.drawImage(img, 0, 0, c.width, c.height);
        var base64String = c.toDataURL("image/png");
        var base64Img = base64String.replace(
          /^data:image\/(png|jpg);base64,/,
          ""
        );
        doc.addImage(base64Img, "JPEG", 15, 10, 30, 18);
      }, 1000);
      doc.addImage(imgUrl, "JPEG", 55, 10, 30, 18);
      doc.setFontSize(10);

      doc.text(15, 40, `Record Name:`);
      doc.text(55, 40, `${this.singlerecord.record.name}`);
      // doc.text(15, 48, `Device ID:`);
      // doc.text(55, 48, `${this.singlerecord.record.device}`);
      doc.setFontSize(14);
      doc.text(15, 60, `SUMMARY`);
      doc.setLineWidth(0.5);
      doc.line(15, 61, 200, 61);
      doc.setFontSize(10);
      doc.text(15, 68, `Start Date:`);
      doc.text(
        55,
        68,
        `${moment(this.singlerecord.record.start, "x", true).format(
          "ddd, MMM Do YYYY, hh:mm a"
        )}`
      );
      doc.text(15, 76, `End Date:`);
      doc.text(
        55,
        76,
        `${moment(this.singlerecord.record.end, "x", true).format(
          "ddd, MMM Do YYYY, hh:mm a"
        )}`
      );
      doc.line(15, 95, 200, 95); //horizontal
      doc.line(15, 270, 200, 270); //horizontal
      doc.line(15, 95, 15, 270); //vertical
      doc.line(200, 95, 200, 270); //vertical

      this.tempGraph = true;
      this.humiGraph = true;
      // var canvasElement = document.createElement("canvas");
      setTimeout(() => {
        // html2canvas(this.$refs.content, { canvas: canvasElement })
        //   .then(function(canvas) {
        //     const img = canvas.toDataURL("image/jpeg", 0.8);
        //     doc.addImage(img, "JPEG", 20, 100, 175, 160);
        //     //console.log("imageadded");
        //     // doc.save("sample1.pdf");
        //     return 90;
        //   })
          domtoimage
            .toPng(node)
            .then(function(dataUrl) {
              doc.addImage(dataUrl, "png", 20, 100, 175, 160);
              // var img = new Image();
              // img.src = dataUrl;
              // document.body.appendChild(img);
            })
          .then(() => {
            this.humiGraph = false;
            if (screen.width < "992") {
                      document.getElementById("my-node").style.width = "100%";
                    }
            doc.save(`${this.singlerecord.record.name}.pdf`);
          })
          .then(() => {
            this.isLoading = false;
          });
      }, 1000);
    },
    endrecord() {
      this.isLoading = true;
      let endtime = new Date();
      // endtime = moment(endtime, true).format("ddd, MMM Do YYYY, hh:mm a");
      endtime = moment(endtime, true).format("YYYY/MM/DD HH:mm");
      endtime = {
        end: endtime,
      };
      this.endGroupRecord({
        id: this.$route.params.id,
        recordId: this.$route.params.record_id,
        endtime,
      })
        .then((res) => {
          if (res.data.status === "success") {
            this.isLoading = false;
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            setTimeout(() => {
              this.mssg = "";
              this.isLoading = true;
              this.fetchSingleGroupRecord({
                id: this.$route.params.id,
                recordId: this.$route.params.record_id,
              })
                .then(() => {
                  this.isLoading = false;
                })
                .catch((error) => {
                  this.isLoading = false;
                  if (error.response) {
                    //console.log(error.response);
                    this.$router.push("/404");
                  }
                });
            }, 1000);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    closeExport() {
      if (this.exportShow == true) {
        this.exportShow = false;
      }
    },
    showGraph(type) {
      if (type == "temp") {
        this.tempGraph = true;
        this.humiGraph = false;
      }
      if (type == "humi") {
        this.humiGraph = true;
        this.tempGraph = false;
      }
    },
    fetchgroupdevicestats(type) {
      this.isLoading = true;
      this.fetchSingleGroupRecordCustom({
        id: this.$route.params.id,
        recordId: this.$route.params.record_id,
        type,
      }).then(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
}

th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
.mylink {
  color: #213e7a !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-decoration-color: #213e7a !important;
}
.tooltip {
  position: relative;
  display: inline-block;
  opacity: 1;
}
.tooltip .tooltiptext {
  width: 120px;
  bottom: 100%;
  left: 50%;
  margin-left: -60px; /* Use half of the width (120/2 = 60), to center the tooltip */
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1070;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}
@media (max-width: 767px) {
  .deleterecord {
    display: flex;
    margin-top: 3px;
    justify-content: flex-start !important;
  }
}
.deleterecord {
  display: flex;
  justify-content: flex-end;
}
.btn-container {
  display: flex;
  justify-content: center;
  width: 50%;
}
.selectrange {
  color: #000 !important;
  background-color: #DEE2EB !important;
}
@media (min-width: 768px) {
  .w-20 {
    width: 20% !important;
  }
}
#graphselect,
#typeselect {
  background-color: inherit;
  border: none;
  color: #213e7a;
  padding: 7px 25px;
  border-radius: 30px;
  outline: none;
}
#graphselect:hover,
#typeselect:hover {
  background-color: #213e7a;
  color: white;
}
#graphselect:disabled,
#graphselect[disabled] {
  background-color: #DEE2EB;
  color: #213e7a;
}
#typeselect:disabled,
#typeselect[disabled] {
  background-color: #d3d9de;
  color: #fff;
}
</style>
<i18n>
{
	"en": {
		"daily": "Daily",
		"default": "Default",
		"del_group": "",
		"del_perm": "Delete this record permanently? This action is not reversible",
		"del_rec": "Delete Record",
		"end_trip": "End Trip",
		"exp": "Export",
		"exp_pdf": "Export as PDF",
		"hrly": "Hourly",
		"monthly": "Monthly",
		"yearly": "Yearly"
	},
	"es": {
		"daily": "diario",
		"default": "Defecto",
		"del_group": "",
		"del_perm": "¿Eliminar este registro de forma permanente? Esta acción no es reversible",
		"del_rec": "Eliminar el registro",
		"end_trip": "Fin de viaje",
		"exp": "Exportar",
		"exp_pdf": "Exportar como PDF",
		"hrly": "Cada hora",
		"monthly": "Mensual",
		"yearly": "Anual"
	},
	"fr": {
		"daily": "du quotidien",
		"default": "Défaut",
		"del_group": "",
		"del_perm": "Supprimer définitivement cet enregistrement ? Cette action n'est pas réversible",
		"del_rec": "Supprimer l'enregistrement",
		"end_trip": "Fin du voyage",
		"exp": "Exportation",
		"exp_pdf": "Exporter au format PDF",
		"hrly": "Horaire",
		"monthly": "Mensuel",
		"yearly": "Annuel"
	},
	"sw": {
		"daily": "Kila siku",
		"default": "Chaguo-msingi",
		"del_group": "",
		"del_perm": "Je, ungependa kufuta rekodi hii kabisa? Kitendo hiki hakiwezi kutenduliwa",
		"del_rec": "Futa Rekodi",
		"end_trip": "Mwisho wa Safari",
		"exp": "Uuzaji nje",
		"exp_pdf": "Hamisha kama PDF",
		"hrly": "Kila saa",
		"monthly": "kila mwezi",
		"yearly": "Kila mwaka"
	}
}
</i18n>